export default () => ({
    topic: '',
    loading: false,
    error: null,
    thread: null,
    isFallback: false,
    loadingMessage: '',
    limitReached: false,
    signupUrl: '/register',
    loadingMessages: [
        'Analyzing your topic...',
        'Crafting engaging hooks...',
        'Optimizing for Threads algorithm...',
        'Adding personality...',
        'Polishing the final draft...',
        'Almost there...'
    ],

    async generate() {
        if (!this.topic.trim()) {
            this.error = 'Please enter a topic';
            return;
        }

        this.loading = true;
        this.error = null;
        this.thread = null;
        this.limitReached = false;
        this.loadingMessage = this.loadingMessages[0];

        // Rotate loading messages
        let messageIndex = 0;
        const messageInterval = setInterval(() => {
            messageIndex = (messageIndex + 1) % this.loadingMessages.length;
            this.loadingMessage = this.loadingMessages[messageIndex];
        }, 1200);

        try {
            const response = await fetch('/api/demo/generate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || ''
                },
                body: JSON.stringify({
                    topic: this.topic
                })
            });

            const data = await response.json();

            if (!response.ok) {
                // Check if limit reached
                if (data.limit_reached) {
                    clearInterval(messageInterval);
                    this.limitReached = true;
                    this.signupUrl = data.signup_url || '/register';
                    this.error = data.error;
                    this.loading = false;
                    return;
                }
                throw new Error(data.error || 'Failed to generate thread');
            }

            // Add dramatic delay (5-8 seconds total)
            const minDelay = 5000;
            const maxDelay = 8000;
            const randomDelay = Math.floor(Math.random() * (maxDelay - minDelay + 1)) + minDelay;

            await new Promise(resolve => setTimeout(resolve, randomDelay));

            clearInterval(messageInterval);

            if (data.success) {
                this.thread = data.thread;
                this.isFallback = data.is_fallback || false;
            } else {
                throw new Error(data.error || 'Generation failed');
            }
        } catch (err) {
            clearInterval(messageInterval);
            this.error = err.message;
            console.error('Demo generation error:', err);
        } finally {
            this.loading = false;
        }
    },

    reset() {
        this.topic = '';
        this.thread = null;
        this.error = null;
        this.isFallback = false;
        this.loadingMessage = '';
        this.limitReached = false;
    }
});
